
import { Record } from 'immutable'
const Auth = Record({
  username:null,
  password:null,
  password_confirm:null
});
export default Auth;
